<template>
  <span class="user-search-results-info-text text-mm text-secondary"><slot /></span>
</template>

<script>
  export default {
    name: 'UserSearchResultsInfoText',
  };
</script>
